// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__2kl8A","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3wmvA"};